import module from 'recursoshumanos/module.js'
import * as moment from 'moment'
import { isArray } from 'lodash'

export class RecursoshumanosVisorloteSUAAltasMasivasService {
  constructor ($http) {
    this.$http = $http
  }

  get ({numeroLote, idEmpresa, clase, proyectos, tipoMovimientoId, fecha, registroPatronalId}) {
    return this.$http.get(`/api/recursos_humanos/sua/altas_masivas`, {
      params: {
        numero_lote: numeroLote,
        id_empresa: idEmpresa,
        clase: clase,
        registroPatronalId: registroPatronalId,
        proyectos: (isArray(proyectos) && proyectos.join()) || undefined,
        tipo_movimiento_id: tipoMovimientoId,
        fecha: fecha && moment(fecha).format('YYYY-MM-DD') || undefined,
      },
      download: true,
    })
  }
}

module.service('RecursoshumanosVisorloteSUAAltasMasivasService', RecursoshumanosVisorloteSUAAltasMasivasService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursoshumanosSUA.js